import React, { useContext } from "react";
import { useLocation, Navigate } from 'react-router-dom';

import { BoerderyContext } from "./context/boerdery-context";
import { ProfielContext } from "./context/profiel-context";
import AccessControl from "./hoc/Access/AccessControl";
import NoAccess from "./components/NoAccess/NoAccess";

const ProtectedRoute = ({
  anyPermissions,
  requiredPermissions,
  saveLocation,
  children
}) => {
  const boerderyContext = useContext(BoerderyContext);
  const profielContext = useContext(ProfielContext);

  const location = useLocation();

  if (boerderyContext.boerderye != null) {
    if (
      boerderyContext.boerderye.length < 1 &&
      location.pathname != "/landingpage"
    ) {
      return <Navigate to="/landingpage" state={{ from: location }} replace />;
    }
  } else {
    return <Navigate to="/loading" state={{ from: location }} replace />;
  }

  return (
    <AccessControl
      permissionsowned={profielContext.profiel.bittoelatings}
      anyPermissions={anyPermissions}
      requiredPermissions={requiredPermissions}
      renderNoAccess={() => <NoAccess />}
    >
      {children}
    </AccessControl>
  );
};

export default ProtectedRoute;
